// Module
var code = "<object type=\"application/pdf\" width=\"100%\" height=\"100%\"> <p>Ce navigateur ne prend pas en compte les PDF</p> </object> ";
// Exports
module.exports = code;